import type { ConversationStatus } from '@/api/types';
import type { InboxFilters, AssignedToFilter } from '../hooks/useInboxFilters';
import { cn } from '@/lib/utils';

interface ConversationFiltersProps {
  filters: InboxFilters;
  onFiltersChange: (updates: Partial<InboxFilters>) => void;
}

const STATUS_OPTIONS: { value: ConversationStatus; label: string }[] = [
  { value: 'open', label: 'Open' },
  { value: 'pending', label: 'Pending' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

const ASSIGNED_OPTIONS: { value: AssignedToFilter; label: string }[] = [
  { value: 'me', label: 'Assigned to me' },
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'all', label: 'All' },
];

export function ConversationFilters({ filters, onFiltersChange }: ConversationFiltersProps) {
  function toggleStatus(status: ConversationStatus) {
    const newStatus = filters.status.includes(status)
      ? filters.status.filter((s) => s !== status)
      : [...filters.status, status];
    onFiltersChange({ status: newStatus });
  }

  return (
    <div className="flex items-center gap-4">
      {/* Status filters */}
      <div className="flex items-center gap-1">
        {STATUS_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => toggleStatus(option.value)}
            className={cn(
              'px-2 py-0.5 text-xs rounded transition-colors',
              filters.status.includes(option.value)
                ? 'bg-slate-800 text-white'
                : 'text-gray-500 hover:bg-gray-100'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>

      <div className="w-px h-4 bg-gray-200" />

      {/* Assigned filter */}
      <div className="flex items-center gap-1">
        {ASSIGNED_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => onFiltersChange({ assignedTo: option.value })}
            className={cn(
              'px-2 py-0.5 text-xs rounded transition-colors',
              filters.assignedTo === option.value
                ? 'bg-slate-800 text-white'
                : 'text-gray-500 hover:bg-gray-100'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
